function decisionChip(decision) {
  switch (decision) {
    case "ACCEPTED":
      return {
        color: "green lighten-2",
        icon: "mdi-check-all",
        decision: "ACCEPTED",
      };

    case "REJECTED":
      return {
        color: "red lighten-2",
        icon: "mdi-cancel",
        decision: "REJECTED",
      };

    default:
      return {
        color: "orange lighten-2",
        icon: "mdi-alert-circle-outline",
        decision: "RESUBMIT",
      };
  }
}

export { decisionChip };
